///<reference path="../require.d.ts"/>

import {parse} from "qs";
import {Room} from "../models/Room";
import {SearchResult} from "../models/SearchResult";
import {CheckedRoomRepository} from "../services/CheckedRoomRepository";

interface RoomInquiry {
    customer_type: string;
    name: string;
    name_kana: string;
    representative: string;
    representative_kana: string;
    tel: string;
    email: string;
    people: string;
    move_in_day: string;
    move_out_day: string;
    period: string;
    questions: string[];
    accept: boolean;
    note: string;
    room_ids: number[];
}

// InquiryController との重複？
class RoomInquiryController {

    static $inject = ["$element", "$http", 'CheckedRoomRepository'];

    contactType: string;
    moveOutDayType: string;

    invalid: boolean = false;
    bulk: boolean;
    result: SearchResult<Room>;
    inquiry: RoomInquiry;
    submitting: boolean = false;
    finished: boolean = false;

    constructor(
        private $element: angular.IAugmentedJQuery,
        private $http: angular.IHttpService,
        private checked: CheckedRoomRepository
    ) {
        const query = location.search.substr(1);
        if (query.length === 0) {
            // MHP-113 トップページに自動遷移
            this.invalid = true;
            // location.href = '/';
            return;
        }
        const param = parse(query).id;
        this.contactType = $element.data('contact');
        this.moveOutDayType = $element.data('moveOut');
        this.initModel(param);
        this.loadRooms();
        // find で見つからないから初期化後の次の実行フレームで
        setTimeout(() => this.initDatePicker(), 0);
    }

    private initDatePicker(): void {
        const $day = this.$element.find('.datepicker');
        if ($day.length === 0) return;
        $day.datepicker({
            format: 'yyyy/m/d (D)',
            todayBtn: 'linked',
            language: 'ja',
            autoclose: true,
            todayHighlight: true,
        });
    }

    private loadRooms(): void {
        this.$http.get<SearchResult<Room>>(`${apiRoot}/rooms${location.search}`).success((result) => {
            this.result = result;
        });
    }

    private initModel(param: any): void {
        this.bulk = !angular.isString(param);
        const ids = (this.bulk ? param as string[] : [param]).map((s) => Number(s));
        this.inquiry = {
            room_ids: ids,
            customer_type: '個人',
            name: '',
            name_kana: '',
            representative: '',
            representative_kana: '',
            tel: '',
            email: '',
            people: '',
            move_in_day: '',
            move_out_day: '',
            period: '',
            questions: [],
            accept: false,
            note: '',
        };
    };

    toggle(id: number): void {
        if (this.inquiry.room_ids.indexOf(id) >= 0) {
            this.inquiry.room_ids = this.inquiry.room_ids.filter((i) => i !== id);
        } else {
            this.inquiry.room_ids.push(id);
        }
    }

    get rooms(): Room[] {
        if (this.invalid) return [];
        return this.result.items;
    }

    get nameLabel(): string {
        if (this.invalid) return '';
        if (this.company) {
            return '御社名';
        } else {
            return 'お名前';
        }
    }

    get nameKanaLabel(): string {
        if (this.invalid) return '';
        return this.nameLabel + 'カナ';
    }

    get company(): boolean {
        if (this.invalid) return false;
        return this.inquiry.customer_type === '法人';
    }

    selectQuestion(selected: boolean, value: string): void {
        if (selected) {
            this.inquiry.questions.push(value);
        } else {
            this.inquiry.questions = this.inquiry.questions.filter((q) => q !== value);
        }
    }

    submit(form: angular.IFormController): void {
        if (/\/preview\/\d+$/.test(location.pathname)) {
            alert("プレビューではお問い合わせはできません。");
            return;
        }
        if (this.inquiry.room_ids.length === 0) {
            alert("お問い合わせする物件を選択してください。");
            return;
        }
        if (this.contactType === 'tel_or_mail') {
            const tel = form['tel'] as angular.INgModelController;
            const mail = form['email'] as angular.INgModelController;
            const valid = this.inquiry.tel !== '' || this.inquiry.email !== '';
            tel.$setValidity('required', valid);
            mail.$setValidity('required', valid);
        }
        if (this.moveOutDayType === 'day_or_period') {
            const moveOutDay = form['move_out_day'] as angular.INgModelController;
            const valid = this.inquiry.move_out_day !== '' || this.inquiry.period !== '';
            moveOutDay.$setValidity('required', valid);
            moveOutDay.$setValidity('required', valid);
        }
        if (!form.$valid) {
            for (let key in form) {
                if (!/^\$/.test(key)) {
                    form[key].$setDirty();
                }
            }
            alert("入力エラーがあります。\n表示が赤い箇所を確認してください。");
            return;
        }
        if (!this.inquiry.accept) {
            alert("個人情報保護に同意してください");
            return;
        }
        const params: any = this.inquiry;
        params.questions = this.inquiry.questions.join("\n");
        this.submitting = true;
        this.$http.post<void>(`${apiRoot}/room-inquiries`, params).success(() => {
            this.trackConversion();
            this.finished = true;
            if (this.bulk) this.checked.clear();
            setTimeout(() => $('html,body').animate({scrollTop: 0}, 'slow'), 0);
        });
    }

    private trackConversion(): void {
        const $conv = $("#google-conversion");
        if ($conv.length === 0) return;
        const w = window as any;
        w.google_conversion_format = "3";
        w.google_conversion_id = $conv.data('googleConversionId');
        w.google_conversion_label = $conv.data('googleConversionLabel');
        if ($conv.data('googleConversionValue')) {
            w.google_conversion_value = $conv.data('googleConversionValue');
        }
        if ($conv.data('googleConversionCurrency')) {
            w.google_conversion_currency = $conv.data('googleConversionCurrency');
        }
        w.google_remarketing_only = $conv.data('googleRemarketingOnly');
        const track: Function = w['google_trackConversion'];
        if (typeof(track) === 'function') {
            track({});
        }
    }

}

angular.module('hp').controller('RoomInquiryController', RoomInquiryController);



// WEBPACK FOOTER //
// ./controllers/RoomInquiryController.ts